/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerSalesContractService = {
  /**
   * Get Screen data
   *
   * */
  async save(_payload) {
    var payload = _payload;
    var url = "api/CustomerSalesContractNote";
    return await ApiService.post(url, payload);
  },
  async saveAll(_payLoad) {
    var payLoad = _payLoad;
    var url = "api/Save_CustomerSalesContractNoteList";
    return await ApiService.post(url, payLoad);
  },
  async getByCode(code) {
    const requestScreenData = {
      url: "api/CustomerSalesContract",
      expand: "CustomerSalesContractNoteList",
      top: "1",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getCustomerSalesContractItems(customerCode, salesOrderCode) {
    const requestScreenData = {
      url: "api/CustomerSalesContractSalesOrderItem",
      top: "1000",
      key: "Code",
      filter:
        "SalesOrderCode eq " +
        salesOrderCode.toString() +
        // " and CustomerSalesContractLine/CustomerSalesContract/CustomerCode eq '" +
        // customerCode +
        // "'
        " and CustomerSalesContractLine/CustomerSalesContract/Status eq 'A'", // +  also Active Contracts order by StartDate, CustomerSalesContractCode, CustomerSalesContractLineNo

      expand:
        "CustomerSalesContractLine($expand=CustomerSalesContract($select=CustomerCode,StartDate,Status),CustomerSalesContractItemConsumptions)",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getCustomerSalesContractSalesOrderConsumptionBySalesOrder(
    salesOrderCode
  ) {
    var filter = "SalesOrderCode eq " + salesOrderCode + "";

    const requestScreenData = {
      url: "api/CustomerSalesContractSalesOrderConsumption",
      filter: filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getCustomerSalesContractSalesOrderConsumption(salesOrderCode) {
    var filter = "SalesOrderCode ne " + salesOrderCode + "";

    const requestScreenData = {
      url: "api/CustomerSalesContractSalesOrderConsumption",
      // top: "1000",
      key: "Code",
      // select:
      //   "CustomerSalesContractCode, CustomerSalesContractLineNo, DrawnQuantity",
      apply:
        "filter(" +
        filter +
        ")/groupby((CustomerSalesContractCode,CustomerSalesContractLineNo),aggregate(DrawnQuantity with sum as DrawnQuantity))",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getCustomerSalesContractItemConsumption(customerSalesContractCode) {
    const requestScreenData = {
      url: "api/CustomerSalesContractItemConsumption",
      top: "1000",
      filter: `CustomerSalesContractCode eq ${customerSalesContractCode}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getCustomerSalesContractLineConsumption(customerSalesContractCode) {
    const requestScreenData = {
      url: "api/CustomerSalesContractLineConsumption",
      top: "5000",
      filter: `CustomerSalesContractCode eq ${customerSalesContractCode}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getCustomerSalesContractLineConsumptionByLineNo(
    customerSalesContractCode,
    customerSalesContractLineNo
  ) {
    const requestScreenData = {
      url: "api/CustomerSalesContractLineConsumption",
      top: "5000",
      filter: `CustomerSalesContractCode eq ${customerSalesContractCode} and LineNo eq ${customerSalesContractLineNo}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getLatestConfirmationNo(
    customerCode,
    salesContractCode,
    confirmationNoFactorInt
  ) {
    //  "Entity": "SalesOrder",
    //                 "Top": "1",
    //                 "Select": "UserComment" + window.ViewModel.factor(650).FactorInt,
    //                 "Filter": "CustomerCode eq '" + self.CustomerCode() + "' and contains(UserComment" + window.ViewModel.factor(650).FactorInt + ",'" + window.ViewModel.Screen.Code() + "-')",
    const requestScreenData = {
      url: "api/SalesOrder",
      top: "1",
      select: "UserComment" + confirmationNoFactorInt,
      filter:
        "CustomerCode eq '" +
        customerCode +
        "' and contains(UserComment" +
        confirmationNoFactorInt +
        ",'" +
        salesContractCode +
        "-')",
      orderby: "DateCreated desc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },


  async getCustomData(requestScreenData) {
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerSalesContractService };
